export const USER_PROFILE = "/getUserProfileDetail";
export const LIST_APPLICATION = "/listAllApplicationMenu";
export const LOG_OUT_USER = "/logOutUser";
export const GENERATE_USER_TEMP_TOKEN = "/generateUserTempToken";
export const SIDE_MENU = "/getDashboardPageSideMenu";
export const NINE_DOTS = "/getDashboardHeaderNineDots";
export const SYSTEM_PAGE = "/detailSystemPages";
export const LOGIN = "/login";
export const SEND_MAGIC_LINK = "/sendFreeTrialMegicLinkEmail";
export const LOGIN_WITH_MAGIC_LINK = "/loginWithMagicLink";
export const FREE_TRIAL_RESET_PASSWORD_EMAIL =
  "/sendFreeTrialResetPasswordEmail";

export const SAVE_SIGNUP_MATRIC_REPORT = "/savesignupMetricReport";
export const GET_REGISTER_SECURITY_QUESTION = "/getSecurityQuestion";
export const SIGNUP = "/register";
export const FORGOT_PASSWORD = "/resetUserPassword";
export const CHANGE_USER_NAME = "/updateEmailOrUsername";
export const CHANGE_PASSWORD = "/changePassword";
export const CHANGE_SECURITY_QUESTION = "/saveSecurityQuestionAnswer";
export const UPDATE_USER_PROFILE = "/addUpdateUserProfile";
export const LIST_TUTORIAL = "listAllTutorialsv1";
export const LIST_SUBSCRIPTION = "listSubscription";
export const USER_CARD_DETAILS = "userCardDetail";
export const GET_USER_MEMBERSHIPS_VOLUMES = "/getUserMembershipVolumes";
export const LIST_SITE = "/listSite";
export const ADD_STRIP_CUSTOMER_CARD = "/addStripeCustomerCard";
export const EDIT_STRIP_CUSTOMER_CARD = "/edituserCardDetail";
export const DELETE_STRIP_CARD = "/deleteuserCardDetail";
export const USER_SUBSCRIPTION_DETAILS = "/getUserSubscriptionDetail";
export const UPDATE_EMAIL_OR_USERNAME = "/updateEmailOrUsername";
export const TRANSFER_SUBSCRIPTION = "/transferSubscription";
export const REACTIVATE_SUBSCRIPTION = "/reactiveSubscription";
export const UPDATE_SUBSCRIPTION_STATUS = "/cancelSubscription";
export const GET_ORDER_DETAILS = "/getOrderDetails";
export const GET_CONFIRM_PRODUCT_DETAIL = "/confirmProductDetail";

export const LIST_COUNTRY = "/listCountry";
export const LIST_STATE = "/listState";
export const UPDATE_BILLING_SHIPPING_ADDRESS =
  "/updateBillingShippingAddressDetail";
export const SEND_CHARGE_RECEIPT = "/chargeTransactionReceipt";
export const GET_PAYMENT_TOKEN = "/getPaymentToken";
export const SUBSCRIPTION_CARD = "/subscriptionUpdatePaymentCard";
export const SUBSCRIPTION_INSTANT_PAYMENT = "/subscriptionInstantPayment";
export const GET_SHIP_BOB_ORDER = "/getShipbobOrders";
export const GET_SHIPMENT_TIME_LINE = "/getShipmentTimeline";
export const CONFIRM_PRODUCT_DETAIL = "/confirmProductDetail";
// export const VERIFY_COUPON = "/verifyCoupon";
export const VERIFY_COUPON = "/verifyCoupon_v2";

export const VERIFY_CUSTOM_CHECKOUT_PRODUCT = "/verifyCustomCheckOutProduct";
// This api is comment due to guest checkout flow
// export const UPDATE_USER_CART_USER_ID = "/updateUserCartUserId";
export const UPDATE_USER_CART_USER_ID = "/updateUserCartUserId_v2";
export const SAVE_SUBSCRIPTION_DETAILS = "/saveUserCartDetail";
export const GET_USER_CART_DETAIL = "/getUserCartDetail";
export const SAVE_ADDRESS_DETAIL = "/saveAddressDetail";
export const SITE_VISIT = "/siteVisit";
// export const CHECKOUT_USER_SUBSCRIPTION = "/checkOutUserSubscription";
export const CHECKOUT_USER_SUBSCRIPTION = "/checkOutUserSubscription_V2";

export const CUSTOM_CHECKOUT_USER_SUBSCRIPTION =
  "/customCheckOutUserSubscription";
// export const DELETE_USER_CART = "/deleteUserCartDetail";
export const DELETE_USER_CART = "/deleteUserCartDetail_v2";

export const VERIFY_OTP = "/verifyOtp";
export const VERIFY_RESET_PASSWORD_TOKEN = "/validateResetPasswordToken";
export const UPDATE_PASSWORD = "/updateUserPassword";
export const GET_USER_SECURITY_QUESTION = "/getUserAddedSecurityQuestion";
export const VERIFY_USER_SECURITY_QUESTION_ANSWER =
  "/verifyUserSecurityQuestionAnswer";
export const SHARED_DASHBOARD_DATA = "getSharedDashboardV2";
export const DELETE_SHARED_DASHBOARD_DATA = "/deleteSharedDashboardV2";
export const GET_USER_SHARE_MEMBERSHIP = "/getUserShareContentData";
export const GET_USER_SHARED_PAGES_CONTENT = "/getUserSharedPagesContentV2";
export const SAVE_SHARED_DASHBOARD = "/saveSharedDataV2";
export const CHECK_IS_USER_SHARED = "/checkIsUserSharedV2";
export const DELETE_SUBSCRIPTION_ITEM = "/deleteUserSubscriptionItem";
export const VERIFY_ACCOUNT = "/verifyAccount";
export const CHECK_USER_HAVING_SAME_SUBSCRIPTION_URL =
  "/checkUserHavingSameSubscription";
export const CHECK_USER_HAVING_SAME_SUBSCRIPTION_URL_V2 =
  "checkUserHavingSameSubscription_v2";
export const SAVE_ADDRESS_DETAILS = "/saveAddressDetail";
export const GET_CART_DETAILS = "/getUserCartDetail";
export const GET_CART_DETAILS_V2 = "/getUserCartDetail_v2";

export const GET_STATES = "/listState";
export const GET_COUNTRIES = "/listCountry";

export const FEED_BACK_OPTION_DATA = "/FeedbackOptionData";

//Auth Feedback
export const ADD_FEEDBACK = "/add-feedback";

// Get Coupon for freetrial
export const GET_FREE_TRIAL_USER_COUPON = "/getFreeTrialUserCoupon";

// Invitation
export const GET_HUB_INVITED_DATA = "/getHubInvitedData";
export const ACCEPT_INVITATION = "/acceptInvitation";

//Resend Invitation
export const RESEND_SHARE_DASHBOARD = "/resendSharedDashboardV2";

//check Shipping bob Token
export const CHECK_SHIPPBOB_TOKEN = "/checkShipbobToken";
export const UPDATE_SHIPBOB_USER_ADDRESS = "/updateShipbobUserAddress";

//Guest Checkout Api
export const verifyAccountV2 = "/verifyAccount_v2";
export const registerAccountV2 = "/register_v2";

//ADD_PARTNER_AC_TAG
export const ADD_PARTNER_AC_TAG = "/addPartnerACTag";

//get product data for active product
export const GET_ACTIVE_PRODUCT = "/getProductsForFreeTrial";
